import effects from 'app/effects/effects'
import {
  errorTypes,
  networkErrorDetails,
  networkErrorToMessage,
} from 'commons/error'

import { errorCode } from 'app/constants/errorCode'

export const emailType = {
  official: 'official',
  existence: 'existence',
}

export const checkEmail = async (formatMessage, email, type) => {
  let error = null
  const isExistence = type === emailType.existence

  try {
    await effects.apis.checkEmail({ email, isExistence })
    error = null // No error, email is valid
  } catch (errorResponse) {
    const errorMessage = networkErrorToMessage(formatMessage)(
      errorResponse,
      errorTypes.emailField,
    )
    const errorDetails = networkErrorDetails(errorResponse)
    error =
      errorDetails?.code === errorCode?.emailAllReadyExist
        ? formatMessage({ id: 'error.400.emailExist' })
        : (errorMessage?.message ?? errorDetails?.message)
  }

  return error // Return the error (or null if no error)
}
